import { useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { LoadingComponent } from "../components/LoadingComponent";
import { useProfile } from "../components/ProfileContext";
import { UserInfoLabel } from "../components/UserInfoLabel";
import { inspectionInterval } from "../dependencies";
import { Clipboard, Front } from "react-bootstrap-icons";

export function SharingFormModal(props) {
	let {
		show,
		setShow,
		sharingObject,
		profile,
		sharingLink
	} = props;
	
	let [shareList, setShareList] = useState(null);
	let [showShareLink, setShowShareLink] = useState(false);
	let [isLinkedCopied, setIsLinkCopied] = useState(false);

	useEffect(async () => {
		if(show && shareList == null) {
			setShareList(await sharingObject.getSharedRecipients(profile));
		}
	});

	let connections = profile?.getConnections() || [];
	let isSharedWithUser = {}
	let allPossibleSharers = connections.map(x => x.id.toString()).concat((shareList || []).map(x => {
		let uid = x.sharedWithUserIdentifier;
		isSharedWithUser[uid] = true;
		return uid;
	}));
	allPossibleSharers = [...new Set(allPossibleSharers)].sort(); // uniq/sort the array

	let shareChanges = {};
	let markShareAction = (uid) => (evt) => {
		let isChecked = evt.target.checked;
		shareChanges[uid] = isChecked;
	};

	let cancelAction = () => setShow(false);
	let saveAction = async () => {
		try {
			for(const uid in shareChanges) {
				let isChecked = shareChanges[uid];
				if(isChecked != (!!isSharedWithUser[uid])) {
					if(isChecked) {
						await sharingObject.shareWithUser(profile, uid);
					} else {
						await sharingObject.unshareWithUser(profile, uid);
					}
				}
			}	
			setShow(false);
			setShareList(null); // Force a refresh if they bring the dialog up again
		} catch(err) {
			alert("Error sharing: " + err);
		}
	};

	let createSharingLink = () => {
		if(!confirm("Sharing links make the inspection visible to *anyone* with the link.  It is usually best to simply share to individuals that you are connected with.  Are you sure you want to continue?")) {
			return;
		}
		setShowShareLink(true);
	};

	let copyLinkAction = () => {
		navigator.clipboard.writeText(sharingLink);
		setIsLinkCopied(true);
		setTimeout(() => {
			setIsLinkCopied(false);
		}, 2000);
	};

	return <Modal show={show} onHide={cancelAction}>
		<Modal.Header closeButton={true}>
			<Modal.Title>Sharing Options</Modal.Title>
		</Modal.Header>
		<Modal.Body>
			<div className="sharingForm">
				<p>
					Select users you would like this to be shared with:
				</p>
				{shareList == null && <LoadingComponent />}
				{shareList != null && <div className="row">
					{allPossibleSharers.length == 0 && <p>No sharing options available.</p>}
					{allPossibleSharers.map(uid => <div key={uid} className="col-6">
						<input type="checkbox" defaultChecked={isSharedWithUser[uid]} onClick={markShareAction(uid)} /> <UserInfoLabel uid={uid} profile={profile} />
					</div>)}
				</div>}
				<hr />
				<p>
					You can add users to this list by creating additional connections on the Vault™.
				</p>
				<div>
					{!!sharingLink && !showShareLink && <Button onClick={createSharingLink}>Create sharing Link</Button>}
					{showShareLink &&
						<>
							{ /* icons - Back, Files, Front, Clipboard2Add */ }
							<hr />
							<h6>Copy Link</h6>
							<p className="mt-2 float-start">Anyone with the link can view</p>
							<Button onClick={copyLinkAction} variant="outline-secondary" className="float-end">Copy Link</Button>
							{isLinkedCopied && <span className="me-4 mt-2 float-end text-secondary">Link Copied!</span>}
						</>
					}
				</div>
			</div>
		</Modal.Body>
		<Modal.Footer>
			<Button variant="secondary" onClick={cancelAction}>Cancel</Button>
			<Button variant="primary" onClick={saveAction}>Save</Button>
		</Modal.Footer>
	</Modal>;
}